(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[728],{

/***/ 37863:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutors/[slug]",
      function () {
        return __webpack_require__(96859);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ TutorsProfile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./components/tutorProfile/SummaryPanel.js + 1 modules
var SummaryPanel = __webpack_require__(561);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var free_solid_svg_icons_index_es = __webpack_require__(51436);
;// CONCATENATED MODULE: ./components/tutorProfile/SubjectLevelsList.js


function TutorProfileSubjectLevelsList(param) {
    let { tutorProfile  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: tutorProfile.subjects.map((subject)=>{
            const sortedSubjectLevels = tutorProfile.subjectLevels.sort((a, b)=>a.subject.position - b.subject.position || a.level.position - b.level.position);
            const filteredSubjectLevels = sortedSubjectLevels.filter((subjectLevel)=>subjectLevel.subject.id === subject.id);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-2 d-flex flex-wrap",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            className: "d-block mb-2 w-100",
                            children: subject.name
                        }),
                        filteredSubjectLevels.map((subjectLevel)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "bg-light p-2 rounded me-2 mb-2",
                                children: subjectLevel.level.name
                            }, subjectLevel.id))
                    ]
                })
            }, subject.id);
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/tutorProfile/LocationWithSSR.js


function TutorProfileLocationWithSSR(param) {
    let { tutorProfile  } = param;
    const Location = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(269), __webpack_require__.e(194)]).then(__webpack_require__.bind(__webpack_require__, 13194)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(13194)
                ]
        },
        ssr: false
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Location, {
        tutorProfile: tutorProfile
    });
}

;// CONCATENATED MODULE: ./components/tutorProfile/QualificationsList.js





function TutorProfileQualificationsList(param) {
    let { tutorProfile  } = param;
    const sortedQualifications = tutorProfile.qualifications.sort((a, b)=>a.qualificationLevel.position - b.qualificationLevel.position);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "table-responsive",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
            className: "table",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "Level"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "School"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "Subject"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "Grade"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                    children: sortedQualifications.map((qualification)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: qualification.qualificationLevel.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: qualification.schoolName
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: qualification.subjectName
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: qualification.grade
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {})
                            ]
                        }, qualification.id))
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/ClearableInput.module.scss
var ClearableInput_module = __webpack_require__(45638);
var ClearableInput_module_default = /*#__PURE__*/__webpack_require__.n(ClearableInput_module);
;// CONCATENATED MODULE: ./components/ClearableInput.js




function ClearableInput(param) {
    let { children , showClear , onClear  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ClearableInput_module_default()).inputWrapper,
        children: [
            children,
            showClear && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                icon: free_solid_svg_icons_index_es/* faTimesCircle */.nYk,
                size: "sm",
                className: "text-secondary ".concat((ClearableInput_module_default()).clearIcon),
                onClick: onClear
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/tutorProfile/RateList.js



function TutorProfileRateList(param) {
    let { tutorProfile  } = param;
    const sortedSubjectLevels = tutorProfile.subjectLevels.sort((a, b)=>a.level.position - b.level.position || a.subject.position - b.subject.position);
    const [searchTerm, setSearchTerm] = (0,react.useState)("");
    const [filteredSubjectLevels, setFilteredSubjectLevels] = (0,react.useState)(sortedSubjectLevels);
    (0,react.useEffect)(()=>{
        let filtered = sortedSubjectLevels.filter((subjectLevel)=>subjectLevel.subject.name.toLowerCase().match(searchTerm.toLowerCase()) || subjectLevel.level.name.toLowerCase().match(searchTerm.toLowerCase()));
        setFilteredSubjectLevels(filtered);
    }, [
        searchTerm
    ]);
    const clearSearch = ()=>{
        setSearchTerm("");
        setFilteredSubjectLevels(sortedSubjectLevels);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "table-responsive",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
            className: "table",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "d-flex",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClearableInput, {
                                        showClear: !!searchTerm,
                                        onClear: clearSearch,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            value: searchTerm,
                                            placeholder: "Filter by subject or level",
                                            className: "form-control form-control-sm",
                                            onChange: (event)=>setSearchTerm(event.target.value)
                                        })
                                    })
                                })
                            }),
                            tutorProfile.lessonsInPerson && /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "In-Person"
                            }),
                            tutorProfile.lessonsOnline && /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "Online"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                    children: filteredSubjectLevels.map((subjectLevel)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: subjectLevel.displayName
                                }),
                                tutorProfile.lessonsInPerson && /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: subjectLevel.formattedInPersonRate
                                }),
                                tutorProfile.lessonsOnline && /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: subjectLevel.formattedOnlineRate
                                })
                            ]
                        }, subjectLevel.id))
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/react-clamp-lines/lib/index.js
var lib = __webpack_require__(87144);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./components/tutorProfile/Rating.js
var Rating = __webpack_require__(79963);
// EXTERNAL MODULE: ./components/tutorProfile/ReviewsList.js
var ReviewsList = __webpack_require__(56746);
;// CONCATENATED MODULE: ./pages/tutors/[slug].js

















var __N_SSG = true;
function TutorsProfile(param) {
    let { tutorProfile , reviews  } = param;
    const showRating = tutorProfile.tutorReviewsCount > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        tutorProfile.firstNameAndLastInitial,
                        " | Tutors | Tutorspot"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                className: "pt-3 mb-5 flex-grow-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            xs: 12,
                            md: 3,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                    className: "mb-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryPanel/* default */.Z, {
                                            tutorProfile: tutorProfile
                                        })
                                    })
                                }),
                                tutorProfile.lessonsInPerson && tutorProfile.locationComplete && /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                    className: "mb-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Title */.Z.Title, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons_index_es/* faMapMarkerAlt */.FGq,
                                                        size: "lg",
                                                        className: "text-success me-2"
                                                    }),
                                                    "Location"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorProfileLocationWithSSR, {
                                                tutorProfile: tutorProfile
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            xs: 12,
                            md: 9,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                    className: "mb-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-md-flex justify-content-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "d-md-flex mb-3 mb-md-0",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                            className: "my-auto mr-md-3 mb-2 mb-md-0",
                                                            children: tutorProfile.firstNameAndLastInitial
                                                        }),
                                                        showRating && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "my-auto ms-1",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                                                tutorProfile: tutorProfile
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "d-md-flex my-auto",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                        href: "/tutors/".concat(tutorProfile.slug, "/send-message"),
                                                        className: "btn btn-primary btn-lg",
                                                        passHref: true,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                icon: free_solid_svg_icons_index_es/* faComments */.lXL,
                                                                className: "me-2"
                                                            }),
                                                            "Send Message"
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                    className: "mb-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Title */.Z.Title, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons_index_es/* faUserCircle */.m08,
                                                        fixedWidth: true,
                                                        className: "text-success me-2"
                                                    }),
                                                    "About ",
                                                    tutorProfile.firstName
                                                ]
                                            }),
                                            tutorProfile.biography && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mb-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                        children: "Biography"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                                                        text: tutorProfile.biography,
                                                        lines: 5,
                                                        id: "1",
                                                        moreText: "More",
                                                        lessText: "Less"
                                                    })
                                                ]
                                            }),
                                            tutorProfile.experience && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mb-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                        children: "Tutoring Experience"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                                                        text: tutorProfile.experience,
                                                        lines: 5,
                                                        id: "2",
                                                        moreText: "More",
                                                        lessText: "Less"
                                                    })
                                                ]
                                            }),
                                            tutorProfile.lessonPlan && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mb-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                        children: "Lesson Planning"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                                                        text: tutorProfile.lessonPlan,
                                                        lines: 5,
                                                        id: "3",
                                                        moreText: "More",
                                                        lessText: "Less"
                                                    })
                                                ]
                                            }),
                                            tutorProfile.examFamiliarity && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mb-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                        children: "Exam Board Experience"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                                                        text: tutorProfile.examFamiliarity,
                                                        id: "4",
                                                        moreText: "More",
                                                        lessText: "Less"
                                                    })
                                                ]
                                            }),
                                            tutorProfile.pastSuccess && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mb-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                        children: "Past Success Stories"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                                                        text: tutorProfile.pastSuccess,
                                                        lines: 5,
                                                        id: "5",
                                                        moreText: "More",
                                                        lessText: "Less"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                showRating && /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                    className: "mb-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Title */.Z.Title, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons_index_es/* faStar */.Tab,
                                                        fixedWidth: true,
                                                        size: "lg",
                                                        className: "text-success me-2"
                                                    }),
                                                    "Reviews"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsList/* default */.Z, {
                                                tutorProfile: tutorProfile,
                                                reviews: reviews
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                    className: "mb-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Title */.Z.Title, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons_index_es/* faBook */.FL8,
                                                        fixedWidth: true,
                                                        size: "lg",
                                                        className: "text-success me-2"
                                                    }),
                                                    "Subjects"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorProfileSubjectLevelsList, {
                                                tutorProfile: tutorProfile
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                    className: "mb-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Title */.Z.Title, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons_index_es/* faGraduationCap */.Xf_,
                                                        fixedWidth: true,
                                                        size: "lg",
                                                        className: "text-success me-2"
                                                    }),
                                                    "Qualifications"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorProfileQualificationsList, {
                                                tutorProfile: tutorProfile
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                    className: "mb-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Title */.Z.Title, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons_index_es/* faMoneyBill */.aLp,
                                                        fixedWidth: true,
                                                        size: "lg",
                                                        className: "text-success me-2"
                                                    }),
                                                    "Rates"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorProfileRateList, {
                                                tutorProfile: tutorProfile
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                    className: "mb-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                        className: "d-flex justify-content-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "h3 me-3 my-auto",
                                                children: [
                                                    "Contact ",
                                                    tutorProfile.firstName,
                                                    " for free"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                href: "/tutors/".concat(tutorProfile.slug, "/send-message"),
                                                className: "btn btn-primary btn-lg",
                                                passHref: true,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons_index_es/* faComments */.lXL,
                                                        className: "me-2"
                                                    }),
                                                    "Send Message"
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 45638:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"ClearableInput_inputWrapper__xCcg5","clearIcon":"ClearableInput_clearIcon__PoCHW"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [766,809,764,940,774,888,179], function() { return __webpack_exec__(37863); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);